import React, { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Drawer,
  FormControlLabel,
  FormGroup,
  InputBase,
  Paper,
  Stack,
  Tooltip,
  Typography,
  styled,
} from "@mui/material";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import close from "../assets/svg/drawer_close.svg";
import arrow from "../assets/svg/backspace.svg";
import speaker from "../assets/svg/speaker.svg";
import volumn_on from "../assets/svg/volume_on.svg";
import volumn_off from "../assets/svg/volume_off.svg";
import send from "../assets/svg/send.svg";
import postpalLogo from "../assets/svg/logo_blue.svg";
import SimpleBar from "simplebar-react";
import { useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";
import { toast } from "react-toastify";

function TableItemDocuments({
  data,
  open,
  onClose,
  packageActiveData,
  userActiveData,
  packageCollection,
  shipmentCollection,
}) {
  const [formDetails, setFormDetails] = useState({});

  useEffect(() => {
    const fetchFormIds = async () => {
      try {
        const docRef = doc(db, "forms", data?.itemId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setFormDetails(docSnap.data());
        } else {
          console.log("No such document!");
        }
      } catch (err) {
        console.log(err, "err");
      }
    };
    fetchFormIds();
  }, [data?.itemId]);

  return (
    <Drawer
      variant="temporary"
      anchor="right"
      open={open}
      onClose={onClose}
      BackdropProps={{ sx: { background: "rgba(0, 0, 0, 0.5)" } }}
    >
      <Box sx={{ display: "flex" }}>
        <Box>
          <Box
            sx={{
              borderBottom: "1px solid #E5E5E8",
              paddingLeft: "20px",
              paddingTop: "20px",
              paddingBottom: "5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "572px",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box
                sx={{ cursor: "pointer", marginRight: "20px" }}
                onClick={() => {
                  onClose();
                }}
              >
                <img
                  src={arrow}
                  alt="back_arrow"
                  style={{ minHeight: "24px", minWidth: "24px" }}
                />
              </Box>
              <Box sx={{ cursor: "pointer", marginRight: "20px" }}>
                {data?.item_img ? (
                  <img
                    src={data?.item_img}
                    alt="item_image"
                    width="40px"
                    height="40px"
                  />
                ) : (
                  <img
                    src={postpalLogo}
                    alt="postpalLogo"
                    width="40px"
                    height="40px"
                  />
                )}
              </Box>
              <Typography variant="h5" component="h5">
                <Tooltip
                  title={`${data?.fullName}'s Documents`}
                  arrow
                  placement="bottom"
                >
                  {`${data?.fullName}'s Documents`.split(' ').slice(0,3).join(' ') + "..."}
                </Tooltip>
              </Typography>
            </Box>
            <Box
              sx={{ paddingRight: "20px", cursor: "pointer" }}
              onClick={onClose}
            >
              <img src={close} alt="close" />
            </Box>
          </Box>
          <SimpleBar
            forceVisible="y"
            autoHide={true}
            style={{ maxHeight: "90vh" }}
            className="custom-scrollbar"
          >
            <Box className="p-2">
              {formDetails?.InspectionForm?.isDocGenerated && (
                <Box className="flex justify-between p-4 mb-2 bg-slate-200 rounded-lg">
                  <Typography style={{ fontSize: "18px", fontWeight: "bold" }}>
                    Inspection Report
                  </Typography>
                  <p
                    className="underline text-blue-600 cursor-pointer"
                    onClick={() => {
                      window.open(
                        formDetails?.InspectionForm?.docUrl,
                        "_blank"
                      );
                    }}
                  >
                    View
                  </p>
                </Box>
              )}
              {formDetails?.ConditionForm?.isDocGenerated && (
                <Box className="flex justify-between p-4 mb-2 bg-slate-200 rounded-lg">
                  <Typography style={{ fontSize: "18px", fontWeight: "bold" }}>
                    Condition Report
                  </Typography>
                  <p
                    className="underline text-blue-600 cursor-pointer"
                    onClick={() => {
                      window.open(formDetails?.ConditionForm?.docUrl, "_blank");
                    }}
                  >
                    View
                  </p>
                </Box>
              )}
              {formDetails?.MeasurementForm?.isDocGenerated && (
                <Box className="flex justify-between p-4 mb-2 bg-slate-200 rounded-lg">
                  <Typography style={{ fontSize: "18px", fontWeight: "bold" }}>
                    Measurement Report
                  </Typography>
                  <p
                    className="underline text-blue-600 cursor-pointer"
                    onClick={() => {
                      window.open(
                        formDetails?.MeasurementForm?.docUrl,
                        "_blank"
                      );
                    }}
                  >
                    View
                  </p>
                </Box>
              )}
              {data?.receipt_img && (
                <Box className="flex justify-between p-4 mb-2 bg-slate-200 rounded-lg">
                  <Typography style={{ fontSize: "18px", fontWeight: "bold" }}>
                    Receipt
                  </Typography>
                  <p
                    className="underline text-blue-600 cursor-pointer"
                    onClick={() => {
                      window.open(data?.receipt_img, "_blank");
                    }}
                  >
                    View
                  </p>
                </Box>
              )}
            </Box>
          </SimpleBar>
        </Box>
        {/* <Box sx={{ backgroundColor: "#FAFAFA" }}>
          <Box
            sx={{
              borderBottom: "1px solid #E5E5E8",
              paddingLeft: "20px",
              paddingTop: "20px",
              paddingBottom: "13px",
              display: "flex",
              justifyContent: "space-between",
              width: "462px",
              backgroundColor: "#FAFAFA",
            }}
          >
            <Typography variant="h5" component="h5">
              Shipping Guider
            </Typography>
            <Box
              sx={{
                paddingX: "10px",
                paddingY: "3px",
                cursor: "pointer",
                display: "flex",
                border: "1px solid #5E17EB",
                borderRadius: "8px",
                backgroundColor: "#F3EDFF",
              }}
            >
              <img src={speaker} alt="speaker_icon" />
              <label style={{ marginLeft: "10px" }}>speaker mode</label>
            </Box>
          </Box>
          <Box sx={{ height: "84vh" }}>
            <Accordion
              expanded={expandedTwo === "panel1"}
              onChange={handleChangeTwo("panel1")}
              sx={{ width: 462 }}
            >
              <AccordionSummary
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <label
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                >
                  Packaging Guider
                </label>
              </AccordionSummary>
              <AccordionDetails>
                <Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      backgroundColor: "#FAFAFA",
                      paddingX: "10px",
                      border: "1px solid #E5E5E8",
                      marginTop: "10px",
                      borderRadius: "4px",
                    }}
                  >
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox />}
                        label="Lorem ipsum dolor sit amet"
                      />
                    </FormGroup>
                    <img src={volumn_on} alt="volumn_on" />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      backgroundColor: "#FAFAFA",
                      paddingX: "10px",
                      border: "1px solid #E5E5E8",
                      marginTop: "10px",
                      borderRadius: "4px",
                    }}
                  >
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox />}
                        label="Lorem ipsum dolor sit amet"
                      />
                    </FormGroup>
                    <img src={volumn_on} alt="volumn_on" />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      backgroundColor: "#FAFAFA",
                      paddingX: "10px",
                      border: "1px solid #E5E5E8",
                      marginTop: "10px",
                      borderRadius: "4px",
                      paddingBottom: "20px",
                    }}
                  >
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox />}
                        label="Lorem ipsum dolor sit amet"
                      />
                    </FormGroup>
                    <img src={volumn_off} alt="volumn_on" />
                  </Box>
                </Box>
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedTwo === "panel2"}
              onChange={handleChangeTwo("panel2")}
              sx={{ width: 462 }}
            >
              <AccordionSummary
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <label
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                >
                  General Shipping Procedure
                </label>
              </AccordionSummary>
              <AccordionDetails>
                <Box></Box>
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedTwo === "panel3"}
              onChange={handleChangeTwo("panel3")}
              sx={{ width: 462 }}
            >
              <AccordionSummary
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <label
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                >
                  Warning and Directives
                </label>
              </AccordionSummary>
              <AccordionDetails>
                <Box></Box>
              </AccordionDetails>
            </Accordion>
          </Box>
          <Box
            sx={{
              paddingLeft: "24px",
              marginTop: "20px",
              marginRight: "40px",
            }}
          >
            <Box>
              <Paper
                component="form"
                sx={{
                  p: "2px 4px",
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid #E5E5E8",
                  width: 350,
                  height: 40,
                  marginTop: "10px",
                }}
              >
                <InputBase
                  sx={{ ml: 1, flex: 1 }}
                  placeholder="Search... "
                  inputProps={{ "aria-label": "Ask me a question" }}
                  size="small"
                />
                <img src={send} alt="send" />
              </Paper>
            </Box>
          </Box>
        </Box> */}
      </Box>
    </Drawer>
  );
}

export default TableItemDocuments;
